import { endpointDeclaration } from '@moojo/endpoints'
import { z } from 'zod'

// User is identified by a bearer token (Authorization header)
export const ComputeUseCaseFitRequest = z.object({
  agentId: z.string(),
  // TODO(roman): consider adding useCase field, with default of 'icp'.
})

export type ComputeUseCaseFitRequest = z.infer<typeof ComputeUseCaseFitRequest>

// similar to ComputeTargetingTagsFitResponse
export const ComputeUseCaseFitResponse = z.object({
  score: z.number(),
  qualifyingTagsScores: z
    .object({
      tag: z.string(),
      score: z.number(),
    })
    .array(),
})

export type ComputeUseCaseFitResponse = z.infer<typeof ComputeUseCaseFitResponse>

export const computeUseCaseFitDeclaration = endpointDeclaration(ComputeUseCaseFitRequest, ComputeUseCaseFitResponse)
